module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_agder_neg.4443a437.svg";